export const SUPPORT_URL = "https://hidrent.com/get-support";

export const ROUTES = {
  HOME: "/",
  MENU: "/menu",
  NEW_PROJECT: "/new-project",
  PROJECT_DETAIL: "/project-detail",
  PROJECT_CANCELLED: "/project-cancelled",
  CANCEL_PROJECT: "/cancel-project",
  LOGIN: "/login",
  SIGNUP: "/sign-up",
  RESET_PASSWORD: "/reset-password",
  MY_ACCOUNT: "/my-account",
  MY_PROJECTS: "/my-projects",
  NOTIFICATIONS: "/notifications",
  MESSAGES: "/messages",
  CONTACT_CENTER: "/request-service",
};

export const JOB_STATUSES = {
  PENDING: "pending",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  ASSIGNED: "assigned",
  WAITING: "waiting",
  SCHEDULED: "scheduled",
  DRAFT: "draft",
};

export const JOB_TYPES = {
  WORK: "Work",
  JOB: "Job",
  FRANCHISE: "FranchiseJob",
}

export const LEGAL_LINKS = {
  SUPPORT_URL: `${process.env.REACT_APP_WEB_URL}/get-support`,
  TERMS_OF_USE: `${process.env.REACT_APP_WEB_URL}/terms-of-service`,
  PRIVACY_POLICY: `${process.env.REACT_APP_WEB_URL}/privacy-policy`,
  FAQ: `${process.env.REACT_APP_WEB_URL}/faq`,
};

